module.exports = __webpack_public_path__ + "img/empty-result-img.2bafa518.png";